import React from "react";
import Navbar from "./Navbar";

function AIFaceTrack() {
  return (
    <>
      <Navbar />
      <div className="video-container">
        <video autoPlay loop muted playsInline>
          <source
            src="https://cdn.pixabay.com/video/2020/08/12/46965-449623750_large.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <section className="hero-section">
        <h1 className="hero-title">
          AI-Powered Face Recognition Attendance System
        </h1>
        <p className="hero-description">
          AIFaceTrack is an advanced{" "}
          <strong>AI-driven facial recognition</strong>
          attendance and security system designed for modern educational
          institutions. Using intelligent AI models, it automatically scans,
          verifies, and tracks student attendance with unmatched accuracy and
          security.
        </p>
        <div className="cyhero-buttons">
          <a href="/contactus">
            <button className="cybtn-green">Get Started</button>
          </a>
        </div>
      </section>

      <section className="cychallenges-section">
        <div className="cychallenges-header">
          <h2>Key Features</h2>
          {/* <p>
            Our system addresses the complex challenges of cylinder inventory
            management in godowns, making tracking and record-keeping simple and
            efficient.
          </p> */}
        </div>

        <div className="cyfeatures-grid">
          {[
            {
              title: "AI Face Recognition",
              desc: "Advanced AI models scan and verify student faces in real-time, eliminating proxy attendance and ensuring 100% authenticity.",
              icon: "🤖",
            },
            {
              title: "AI Smart Attendance Automation",
              desc: "Our AI engine automatically marks attendance the moment a face is detected, reducing manual errors and saving administrative time.",
              icon: "🧠",
            },
            {
              title: "AI Geofence Intelligence",
              desc: "AI combines facial recognition with live location tracking to validate presence within authorized campus zones.",
              icon: "📍",
            },
            {
              title: "AI-Based Entry & Exit Monitoring",
              desc: "AI continuously monitors entry and exit points, generating secure time-stamped logs with real-time verification.",
              icon: "🔐",
            },
          ].map((item, idx) => (
            <div key={idx} className="cyfeature-card featured">
              <div className="cyfeature-icon">{item.icon}</div>
              <h3 className="cyfeature-title">{item.title}</h3>
              <p className="cyfeature-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* next section */}
      <div className="hrmkey-features-container">
        {/* <h2 className="hrmsection-title">Key Features</h2> */}

        <div className="hrmfeatures-grid">
          {/* Card 1 */}
          <div className="hrmfeature-card featured">
            {/* <div className="hrmbadge">Featured</div> */}
            <h3 className="hrmfeature-title">
              AI-Powered Biometric Attendance
            </h3>
            <p className="hrmfeature-subtitle">
              Intelligent Face Recognition System
            </p>
            <p className="hrmfeature-description">
              Our AI-based facial recognition engine automatically identifies
              students within seconds. It uses deep learning algorithms to match
              faces with stored profiles, ensuring fast, secure, and accurate
              attendance tracking.
            </p>
            <ul className="hrmfeature-list">
              <li>✔ Real-time AI facial detection</li>
              <li>✔ Deep learning face matching</li>
              <li>✔ Anti-spoofing security protection</li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="hrmfeature-card featured">
            <h3 className="hrmfeature-title">
              AI-Enhanced Student Intelligence
            </h3>
            <p className="hrmfeature-subtitle">
              Smart profile and behavior tracking
            </p>
            <p className="hrmfeature-description">
              AI organizes and analyzes student attendance patterns, behavior
              trends, and activity logs to provide actionable insights for
              administrators.
            </p>
            <ul className="hrmfeature-list">
              <li>✔ AI attendance pattern analysis</li>
              <li>✔ Automated alerts & notifications</li>
              <li>✔ Secure AI data storage</li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className="hrmfeature-card featured">
            <h3 className="hrmfeature-title">
              AI Analytics & Predictive Insights
            </h3>
            <p className="hrmfeature-subtitle">
              Data-driven decision making powered by AI
            </p>
            <p className="hrmfeature-description">
              AI-powered dashboards provide predictive attendance trends, risk
              detection, and performance insights to help institutions make
              smarter operational decisions.
            </p>
            <ul className="hrmfeature-list">
              <li>✔ AI trend forecasting</li>
              <li>✔ Smart attendance alerts</li>
              <li>✔ Exportable AI reports</li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        {/* <div className="hrmbottom-section">
          <div className="hrmimage-placeholder large"></div>
          <div className="hrmbottom-content">
            <h3 className="hrmfeature-title">
              Mobile Access for Parents & Staff
            </h3>
            <p className="hrmfeature-description">
              Our companion mobile app puts attendance information at your
              fingertips:
            </p>
            <ul className="hrmfeature-list">
              <li>Real-time attendance notifications</li>
              <li>Historical attendance records</li>
              <li>Absence reporting for parents</li>
              <li>Direct messaging with school staff</li>
              <li>Permission slips and attendance exemption requests</li>
            </ul>
          </div>
        </div> */}
      </div>

      {/* Header Section */}
      <div className="hrheader-section">
        <div className="hrrrheader-image"></div>
        <div className="hrheader-content">
          <span className="hrtag">Premium Service</span>
          <h1>
            AI-Based <span className="hrhighlight">FACIAL RECOGNITION</span>
            Attendance System
          </h1>
          <p>
            A next-generation AI surveillance and attendance solution that uses
            advanced facial recognition algorithms to identify, verify, and
            track students instantly — with zero manual intervention.
          </p>
          <a href="https://aifacetrack.com/">
            <button className="hrbook-button">You can Visit Here</button>
          </a>
        </div>
      </div>

      <div className="impact-wrapper">
        {/* CTA Section */}
        <div className="cta-section">
          <h2 className="cta-heading">
            Ready to Upgrade to AI-Powered Attendance?
          </h2>
          <p className="cta-text">
            Transform your institution with cutting-edge AI facial recognition
            technology that delivers accuracy, security, and automation — all in
            one platform.
          </p>
          <div className="cta-buttons">
            <a href="https://aifacetrack.com/">
              <button className="demo-btn">Visit site</button>
            </a>
          </div>
        </div>
      </div>
      <style>
        {`
        
  /* Header Section */
  .hrheader-section {
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    padding: 60px;
    justify-content: space-between;
    align-items: center;
    /* margin-bottom: 60px; */
    background: linear-gradient(to bottom right, #cff2f9, #e6d4f9);
  }

  .demo-btn{
  padding: 12px 24px;
  color: white;
  font-size: 17px;
  border: none;
  border-radius: 6px;
  background-color:rgb(26, 138, 243);
  }
  
  .hrheader-content {
    max-width: 600px;
    text-align: right;
  }
  
  .hrtag {
    display: inline-block;
    background-color: #0084d6;
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    margin-bottom: 10px;
  }

  








  /* Challenges Section */
  .cychallenges-section {
    /* padding: 40px 1px; */
    padding-top: 40px;
        width: 100%;

    padding-bottom: 0px;
    text-align: center;
    background-color: white;
  }
  
  .cychallenges-header h2 {
    font-size: 2rem;
    margin-bottom: 10px;
  }
  
  .cychallenges-header p {
    color: #4b5563;
    max-width: 900px;
    margin: 0 auto 40px auto;
  }
  
  .cyfeatures-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 30px;
    max-width: 1500px;
    margin: 0 auto;
  }
  
  .cyfeature-card {
    border: 1px solid #e5e7eb;
    padding: 20px;
    border-radius: 10px;
    text-align: left;
  }
  .cyfeature-card.featured {
    border-color: #1d4ed8;
    box-shadow: 0 0 12px rgba(29, 78, 216, 0.2);
  }
  
  .cyfeature-icon {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
  
  .cyfeature-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 8px;
  }
  
  .cyfeature-desc {
    font-size: 0.95rem;
    color: #374151;
  }










  
  .cta-section {
    background-color: #ffffff;
    text-align: center;
    padding: 40px 20px;
    position: relative;
    z-index: 2;
    /* border-radius: 10px; */
    /* margin-top: 40px; */
  }
  
  .cta-title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .cta-text {
    font-size: 16px;
    margin-bottom: 20px;
  }
  
  .cta-button {
    background-color: rgb(64, 149, 252);
    color: white;
    border: none;
    padding: 12px 25px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .cta-button:hover {
    background-color: rgb(0, 67, 139);
  }
  

    .hero-section {
    /* background-color: #0c7ef0; */
    padding: 150px 20px;
    /* background-color: red; */
    margin-top: 70px;
    text-align: center;
  }
  
  .hero-title {
    font-size: 40px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 10px;
  }

  

   .cybtn-green{
  background-color: #0084d6;
  color: white;
  padding: 12px 25px;
  font-size: 16px;
  border: none;
  position: relative;
  z-index: 2;
  }
  
  .hero-description {
    font-size: 18px;
    color: #ffffff;
  }
  
  .hrheader-content h1 {
    font-size: 36px;
    font-weight: bold;
    margin: 10px 0;
  }
  
  .hrhighlight {
    color: #00a0d6;
  }
  
  .hrheader-content p {
    font-size: 16px;
    margin: 20px 0;
    color: #444;
  }
  
  .hrbook-button {
    /* background-color: #d60000; */
    background-color: #0084d6;

    color: white;
    padding: 12px 24px;
    font-size: 14px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .hrbook-button:hover {
    background-color: #0009b1;
  }
  
  .hrrrheader-image {
    width: 500px;
    height: 350px;
    /* background-color: #e0e0e0; */
    background-image: url("https://cdn.pixabay.com/photo/2018/05/06/10/12/handshake-3378254_640.jpg");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 18px;
    border-radius: 10px;
    margin-top: 20px;
  }






  /* next part */
  .hrmkey-features-container {
    padding-top: 20px;
    font-family: Arial, sans-serif;
    padding-bottom: 20px;
    background-color: white;
    position: relative;
    z-index: 2;
        // backdrop-filter: blur(6px);

  }
  
  .hrmsection-title {
    text-align: center;
    font-size: 30px;
    color: white;
    margin: 0;
    font-weight: bold;
    margin-bottom: 2rem;
  }
  


  
  .hrmfeatures-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
  }
  
  .hrmfeature-card {
    background: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    width: 300px;
    padding: 1rem;
    box-shadow: 0 0 8px rgba(0,0,0,0.05);
    position: relative;
  }
  
  .hrmfeature-card.featured {
    border-color: #1d4ed8;
    box-shadow: 0 0 12px rgba(29, 78, 216, 0.2);
  }
  
  .hrmbadge {
    background: #1d4ed8;
    color: white;
    padding: 0.3rem 0.6rem;
    border-radius: 5px;
    font-size: 12px;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  
  .hrmfeature-title {
    font-size: 18px;
    margin: 0.5rem 0;
    font-weight: bold;
  }
  
  .hrmfeature-subtitle {
    color: #666;
    font-size: 14px;
    margin-bottom: 0.5rem;
  }
  
  .hrmimage-placeholder1 {
    height: 150px;
    background-image: url("https://cdn.pixabay.com/photo/2020/07/08/04/12/work-5382501_640.jpg");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    border-radius: 6px;
  }

  .hrmimage-placeholder2 {
    height: 150px;
    background-image: url("https://cdn.pixabay.com/photo/2016/04/20/08/21/entrepreneur-1340649_640.jpg");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    border-radius: 6px;
  }

  .hrmimage-placeholder3 {
    height: 150px;
    display: flex;
    background-image: url("https://cdn.pixabay.com/photo/2017/10/17/14/10/financial-2860753_640.jpg");
    background-position: center;
    background-size: cover;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    border-radius: 6px;
  }
  
  .hrmimage-placeholder.large {
    height: 250px;
    width: 100%;
    background-image: url("https://cdn.pixabay.com/photo/2020/07/08/04/12/work-5382501_640.jpg");
    background-position: center;
    background-size: cover;
  }
  
  .hrmfeature-description {
    font-size: 14px;
    color: #333;
    margin-bottom: 1rem;
  }
  
  .hrmfeature-list {
    list-style: none;
    padding: 0;
  }
  
  .hrmfeature-list li {
    margin-bottom: 0.5rem;
    font-size: 14px;
  }
  
  .hrmbottom-section {
    margin-top: 3rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    position: relative;
    z-index: 2;
    background: #eaf1fb;
    padding: 2rem;
    /* border-radius: 10px; */
  }
  
  .hrmbottom-content {
    flex: 1;
    min-width: 250px;
  }
        `}
      </style>
    </>
  );
}

export default AIFaceTrack;
